import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { CopyType } from '../entities/copy-type';

@Injectable()
export class CopyTypeService extends BaseCrudService<CopyType> {

  public uri = '/api/copyType/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance CopyTypeService');
  }

  buildSentence(entity?: CopyType, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
            `code${QueryOperator.Equal}${entity.code}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
            `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/copy-type.service.ts